import styled from "styled-components";

interface IPageHeaderContentProps {
  activeTab?: string
}

export const PageHeaderContent = styled.div<IPageHeaderContentProps>`
  position: sticky;
  top: 0;
  // z-index:  ${(props) => (props.activeTab === "possessions" ? "100" : "100")};
   z-index: 2;
  //z-index: 100;
  display: flex;
  justify-content: space-between;
  padding: 20px 63px;
  background: ${({ theme }) => theme.playerHeaderBackground};
  border: 1px solid ${({ theme }) => theme.playerDataBorder};
  backdrop-filter: blur(32px);
  @media(max-width: 1366px){
    padding: 15px 30px;
  }
  & .page-header-buttons {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  & .cta-buttons {
    display: flex;
    padding: 8px 16px 8px 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  & .page-title {
    padding-left: 58px;
  }
`;

export const PageTitle = styled.div`
  padding: 32px 0px;
  background: ${({ theme }) => theme.playerHeaderBackground};
  backdrop-filter: blur(32px);
  // position: sticky;
  top: 90px;
  z-index: 999;
  @media(max-width: 1366px){
    padding: 15px 0px; 
    top: 80px;
  }
  .page-padding {
    margin-left: 63px;
    width: calc(100% - 150px);
    @media(max-width: 1366px){
      margin-left: 30px;
      font-size: 32px;
    }
  }
`;

export const LogoHeader = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;

  & .team-logo {
    width: 42px;
    height: 42px;
    padding: 0px 3.818px 0px 3.938px;
  }
  & .user-text {
    color: ${({ theme }) => theme.playerColor};
    font-family: "Aeonik";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const ForawrdBackwardButton = styled.button`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 300px;
  border: 1px solid ${({ theme }) => theme.tabBorderColor};
  // background: ${({ theme }) => theme.playerCardBackground};
  background:transparent;
  .cta-btn-icons {
    fill: ${({ theme }) => theme.ctaIconsColor};
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
  background: ${({ theme }) => theme.secondaryButtonBackground};

  & .secondary-cta-icon {
    width: 24px;
    color: ${({ theme }) => theme.playerColor};
    filter: ${({ theme }) => (theme.playerColor === "var(--Brand-white-500, #FFF)" ? "grayscale(100%) brightness(0) invert(1)" : "none")};
  }
`;

export const FormationPitchContainer = styled.div`
  margin-top: 20px;
  padding-bottom: 20px;
  // height: 85%;
  overflow-y: scroll;
  box-sizing: border-box;
  -ms-overflow-style: none;
  // scrollbar-width: none;
  overflow-x: clip;
  & img {
    border-radius: 10px;
    width: 100%;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  & > div {
    padding-bottom: 5px;
    margin-top: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
    width: 98%;
  }
  & > div:last-child {
    border-bottom: 0;
  }
  & div > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    & p {
      margin-block-start: 5px;
      margin-block-end: 5px;
    }
    & p:first-child {
      font-weight: 600;
      font-size: 20px;
      font-family: "Aeonik";
      color: ${({ theme }) => theme.playerDataValueColor};
      letter-spacing: 2px;
    }
    & p:nth-child(2) {
      font-weight: 500;
      font-size: 14px;
      font-family: "DM Mono";
      color: ${({ theme }) => theme.NumberColor};
    }
  }
`;

export const ChemistryDetailsContainer = styled.div`
  & > div {
    margin-top: 20px;
  }
  & h5 {
    font-family: "Aeonik";
    font-weight: 700;
    font-size: 24px;
    padding-bottom: 8px;
    color: ${({ theme }) => theme.playerColor};
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
  }
  & p {
    font-family: "Aeonik";
    font-weight: 500;
    font-size: 16px;
    color: ${({ theme }) => theme.NumberColor};
  }
  & h6 {
    font-family: "Aeonik";
    font-weight: 700;
    font-size: 16px;
    margin-block-start: 10px;
    margin-block-end: 5px;
    color: ${({ theme }) => theme.playerColor};
  }
  & b {
    color: ${({ theme }) => theme.playerColor};
  }
  & img {
    width: 14px;
    height: 14px;
    background-color: ${({ theme }) => theme.swapOutIconBackground};
    border: 1px solid ${({ theme }) => theme.swapOutIconBorder};
    border-radius: 100%;
    padding: 2px;
  }
  & .levelContainer {
    display: flex;
    gap: 5px;
    align-items: center;
    margin-top: 0;
    & p {
        margin-block-start: 0;
        margin-block-end: 0;
    }
    & span {
        height: 15px;
        width: 15px;
        border-radius: 5px;
    }
    & span:first-child {
        background-color: #4AF075;
    }
    & span:nth-child(2) {
        background-color: #F2E94E;
    }
  }
`;
